export default __webpack_public_path__ + "static/media/advanced-searches-blue.ca1daa71.png";